import { openNotificationsLog } from "../../modules/units/notifications/views/notification-logs/notifications-log.js";
import { openNotificationsForm } from "../../modules/units/notifications/views/notification-settings/notification-settings.js";


export const createNotificationButtons = (unit) => {
  // Wrapper that will hold the two buttons
  const wrapper = document.createElement('div');
  wrapper.className = 'notifications-btn-group';

  // --- MAIN BUTTON: Notifications LOG ---
  const logButton = document.createElement('button');
  logButton.type = 'button';
  logButton.title = 'NOTIFICATION LOG';
  logButton.className = 'btn btn-primary notifications-main-btn';

  const notificationsIcon = document.createElement('svg');
  notificationsIcon.className = 'buttonicon notificationbluesvg';

  const notificationsButtonText = document.createElement('span');
  notificationsButtonText.innerText = 'Notifications';

  logButton.appendChild(notificationsIcon);
  logButton.appendChild(notificationsButtonText);

  // --- SETTINGS BUTTON: gear icon ---
  const settingsButton = document.createElement('button');
  settingsButton.type = 'button';
  settingsButton.title = 'NOTIFICATION SETTINGS';
  settingsButton.className = 'btn btn-primary notifications-settings-btn';

  const gearIcon = document.createElement('span');
  gearIcon.className = 'notifications-gear-icon';
  gearIcon.textContent = '⚙';

  settingsButton.appendChild(gearIcon);

  // Add both to the wrapper
  wrapper.appendChild(logButton);
  wrapper.appendChild(settingsButton);

  // Click handlers
  logButton.addEventListener('click', (e) => {
    e.stopImmediatePropagation();
    openNotificationsLog(unit);
  });

  settingsButton.addEventListener('click', (e) => {
    e.stopImmediatePropagation();
    openNotificationsForm(unit);
  });

  return wrapper;
};
